import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bs2jawlg3m: FaireBrandEntity = {
  token: "b_bs2jawlg3m",
  type: "brand",
  name: "Infinite Basics",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/3fd78a7d125197bd4aaf53baa30383da5cf25e84f26ae7138c04dbd0a94c729b/1565980825.png",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/4d174dc120178329cf7d0b813311d7d668a27e526fd3d2f2673402f190d37f48/1565905655.jpg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/3fd78a7d125197bd4aaf53baa30383da5cf25e84f26ae7138c04dbd0a94c729b/1565980825.png",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/4d174dc120178329cf7d0b813311d7d668a27e526fd3d2f2673402f190d37f48/1565905655.jpg",
  location: "New York, NY, USA",
  minimumOrderDollars: 50,
  rating: 4.2,
  reviewCount: 81,
  isInsider: true,
  description:
    "Infinite Basics was created to make sourcing trending, high-quality products simple, affordable, and stress-free for retailers. As your go-to destination for on-trend essentials, we offer a curated selection of stylish, functional, and fast-selling items across home, lifestyle, seasonal, and gift categories — all at unbeatable wholesale prices. Our team is constantly tracking the latest trends and negotiating the best deals so you can offer your customers fresh, in-demand products with strong margins.\n\nMore than just a brand, Infinite Basics is a trusted partner dedicated to helping your store grow. With a focus on value, variety, and excellent service, we make it easy to discover new favorites your customers will love — and keep them coming back for more.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:28.125Z",
    importedBy: "entity-db-cli",
  },
};
